import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDifferenceComponent } from "./med-icon-difference.component";

@NgModule({
  declarations: [
    MedIconDifferenceComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDifferenceComponent,
  ],
})
export class MedIconDifferenceModule { }
